import { IconCalendarEvent, IconChecklist, IconSitemap, IconBriefcase2, IconFilter, IconArrowsSort } from "@tabler/icons-react";
import imgs from "../../../../Utils/assets/img/faces/5.jpg";
import { formatDate, usePermissions } from "../../../../Utils/helpers/commonhelper";
import { GetRequest } from "../../../../Utils/hooks/ApiHandler";
import useLocalStorageState from "use-local-storage-state";
import { useEffect, useRef, useState } from "react";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";
import { Badge, Col, Dropdown, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import { useGetRequest } from "../../../../Utils/hooks/QueryHandler";
import { CreateLead } from "../../../Leads/CreateLead";
import { RightLeadDetailsPanel } from "../../../detailPage/leads/RightLeadDetailsPanel";
import { DealActivityPanel } from "../../../deals/DealDetailsComp/DealActivityPanel";
import { FollowUpPage } from "../../../PipelineComponents/FollowUpPage";
import nodata from "../../../../Utils/assets/img/leads_no_data_found_removebg.png";
import { useOutsideClickHandler } from "../../../../Utils/hooks/useOutsideClickHandler";
import { Pagination } from "../../../../CommonComponents/Pagination";
import { FilterPagination } from "../../../../CommonComponents/FIlterPagination";
import Select from "react-select";

export const MyFollowup = ({ searchInput = "" }) => {
    const [customer, setCustomer] = useLocalStorageState('customer');
    // rbac permission 
    const [PERMISSION, _] = useLocalStorageState('permission')
    const customerId = customer?.customer_details?.customer_id;
    const loginUserId = customer?.customer_details?.id;
    const token = customer?.token?.authorization
    const rf = customer?.token?.authentication
    const navigate = useNavigate();
    // API headers configuration
    const headers = {
        Authentication: rf,
        Authorization: token,
    }
    const extras = {
        customer,
        setCustomer,
        rf,
        navigate,
    }

    // rbac  permission for followup with respect to leads and deals
    const leadsFollowupGrant = PERMISSION?.leads?.feature?.followup
    const dealsFollowupGrant = PERMISSION?.deals?.feature?.followup

    const [currModule, setCurrModule] = useState(null);
    // lead or deal id for current selected followup
    const [currId, setCurrId] = useState(null)
    // lead or deal pipeline id for the current followup
    const [currPipelineId, setCurrPipelineId] = useState(null)
    const [myFollowUP, setMyFollowUp] = useState([]);
    const brandColor = "#7a3a5e";
    // const [openDetailsCard, setOpenDetailsCard] = useState(false)

    // for opening dropdown
    const [openFilter, setOpenFilter] = useState(false)
    const filterDropRef = useRef(null)
    const [filter, setFilter] = useState(`Due Followup`)
    const [sort, setSort] = useState("ASC")
    const [showCustomInputs, setShowCustomInputs] = useState(false);
    const [customFrom, setCustomFrom] = useState("");
    const [customTo, setCustomTo] = useState("");
    // email state is being created in order to make sure that the meetings in the corresponding activity panel should be loaded, since it requires email in order to create meeting. So this meeting will be common for both lead and deal and by default will be null so that there are no state duplicacy or incorrect state passing down to components
    // well i need to correct myself that it won't stay null all the time. By default we are setting it to whichever the firstfollowup is in the listing. Below useeffect sets it whenever followup component loads initialy
    const [contactEmail, setContactEmail] = useState(null)

    // pipeline data
    const [pipelineOptions, setPipelineOptions] = useState({})
    const [selectedPipeline, setSelectedPipeline] = useState(null)

    // owner data 
    const [ownerOptions, setOwnerOptions] = useState([])
    const [selectedOwner, setSelectedOwner] = useState(null);

    // pagination states
    const limit = 10;
    const [offset, setOffset] = useState(0)
    const [totalFollowup, setTotalFollowup] = useState(0)
    // Calculate total pages
    const pageCount = Math.ceil(Number(totalFollowup) / 20);
    const displayStartItem = totalFollowup === 0 ? 0 : (offset * 2) + 1;
    const displayEndItem = totalFollowup === 0
        ? 0
        : Math.min((offset * 2) + (limit * 2), totalFollowup);

    // useeffect for setting the first lead or deal module item it
    useEffect(() => {
        if (!myFollowUP) return
        // could be lead or deal module's, item id
        const initialFollowup = myFollowUP[0]
        const id = initialFollowup?.type?.toLowerCase() === "leads" ? initialFollowup?.lead_id : initialFollowup?.deal_id;
        setCurrId(id)
        setCurrPipelineId(initialFollowup?.pipeline_id)
        setCurrModule(myFollowUP[0]?.type?.toLowerCase()?.slice(0, 4));
        setContactEmail(myFollowUP[0]?.email)
    }, [myFollowUP])


    useOutsideClickHandler({
        objRef: filterDropRef,
        isDropdown: openFilter,
        setDropdown: (() => {
            setOpenFilter(false)
            setSelectedOwner(null)
            setSelectedPipeline(null)
        })
    })

    // ----------------------------- fetching owner list data-----------------------
    useEffect(() => {
        const fetchOwnerOptions = async () => {
            try {
                const res = await GetRequest(
                    `/users/users/fetchUserAsOwner/${customerId}`,
                    { headers },
                    extras,
                )

                let data = []

                if (res?.status === "success") {
                    data = res.data.map((user) => ({
                        id: user.id,
                        label: user.full_name,
                    }))
                }

                const isLoginUserIncluded = data.some((user) => user.id === loginUserId)
                setOwnerOptions(data)
            } catch (error) {
                return
            }
        }

        fetchOwnerOptions()
    }, [showCustomInputs])


    // ----------------------------- pipelines fetching for both leads and deals  -----------------------
    const pipelineSelectOptions = Object.entries(pipelineOptions).map(
        ([module, pipelines]) => ({
            label: module.toUpperCase(),
            options: pipelines.map((pipeline) => ({
                value: pipeline.pipeline_id,
                label: pipeline.pipeline_name,
                data: pipeline,
            })),
        })
    );
    /*
        obj = [
            leads : [
                {pipeline_name : "pipe1", pipeline_id : 12}
            ],
            deals : [
                {pipeline_name : "pipe2", pipeline_id : 32}
            ]
        ]
    */
    const fetchPipeline = async () => {
        try {
            const res = await GetRequest(`taskboard/fetchAllPipelines/${customerId}/${loginUserId}/${customer.customer_details?.user_type}`, { headers }, extras)
            if (res.success === false) {
                toast.error(res.message)
                return
            }
            if (res.status === "fail") {
                return
            }

            const grouped = {}
            res.data && res.data?.map((item) => {
                if (!grouped[item.module_name]) {
                    grouped[item.module_name] = [];
                }
                grouped[item.module_name].push(item);
            })
            setPipelineOptions(grouped)
        } catch (error) {
            return
        }
    }
    useEffect(() => {
        fetchPipeline()
    }, [])

    // ----------------------------- Followup fetching -----------------------

    const clearSelection = () => {
        setSelectedPipeline(null);
        setSelectedOwner(null);
        setCustomFrom("");
        setCustomTo("");
    }
    const fetchMyfollowUp = async (filterOverride) => {
        try {
            const activeFilter = filterOverride ?? filter;
            let filterValue = activeFilter.trim().toLowerCase().split(" ").join("_");
            filterValue = filterValue === "all_followup" ? "all" :
                filterValue === "today_followup" ? "today" :
                    filterValue === "due_followup" ? "due" : 'custom';
            // if the limit is for 50 then i have to sent the half of it since followup includes both leads and deals which are being fetched seperately from respective tables.
            const res = await GetRequest(`taskboard/pendingFollowups/${customerId}/${loginUserId}/${filterValue}/${customer.customer_details?.user_type}?from=${customFrom}&to=${customTo}&limit=${limit}&offset=${offset}&search=${searchInput}&owner_id=${selectedOwner?.value || ""}&pipeline_id=${selectedPipeline?.pipeline_id || ""}&sort=${sort}`, { headers }, extras);
            if (res.success === false) {
                toast.error(res.message);
                setTotalFollowup(res?.total_count)
                setMyFollowUp([])
                return
            }
            if (res.status === "fail") {
                // toast.error("");
                setTotalFollowup(res?.total_count)
                setMyFollowUp([])
                return
            }
            setTotalFollowup(res?.total_count)
            setMyFollowUp(Array.isArray(res.data) ? res.data : []);
        } catch (error) {
            return
        }
    };

    useEffect(() => {
        fetchMyfollowUp(filter);
    }, [filter, offset, sort]);

    // just to ensure when user will make any search then whichever current page it is on that should be reset to 0
    useEffect(() => {
        if (searchInput?.trim()?.length !== 0) {
            setOffset(0)
        }
        fetchMyfollowUp()
    }, [searchInput])

    // Priority styling helper
    const getPriorityColor = (p) => {
        const colors = { high: '#ef4444', medium: '#f59e0b', low: '#10b981' };
        return colors[p?.toLowerCase()] || '#64748b';
    };

    const getStatusColor = (status) => {
        switch (status?.toLowerCase()) {
            case "medium":
                return "text-warning"
            case "low":
                return "text-primary"
            case "high":
                return "text-danger"
            default:
                return "bg-secondary"
        }
    }

    return (
        <Row
            className="Projectscard w-100 mx-0 g-0"
        >
            <Col md={5} className="ms-0 d-flex listStyleForContact flex-column gap-2 px-3 pb-3 pt-0 meetings-scroll-container " style={{ minHeight: "calc(100vh - 14rem)", maxHeight: "calc(100vh - 14rem)", overflowY: "auto", overflowX: "hidden", position: 'relative', borderRight: "1px solid rgb(224, 228, 248)" }}>
                <div
                    className="d-flex align-items-center justify-content-between position-sticky py-2 px-1"
                    style={{
                        top: "0rem",
                        zIndex: 100,
                        background: "white",
                    }}
                >
                    <p className="mb-0 fs-12" style={{ fontSize: "14px" }}>
                        Showing {displayStartItem}-{displayEndItem} of {totalFollowup} items
                    </p>
                    <div className="d-flex align-items-center gap-2">
                    <OverlayTrigger
                        placement="bottom"
                        overlay={
                            <Tooltip id="followup-sort-tooltip">
                                {sort === "ASC" ? "Ascending" : "Descending"}
                            </Tooltip>
                        }
                    >
                        <button
                            type="button"
                            aria-label={sort === "ASC" ? "Sort by date ascending" : "Sort by date descending"}
                            onClick={() => {
                                setOffset(0)
                                setSort((prev) => (prev === "ASC" ? "DESC" : "ASC"))
                            }}
                            className="btn btn-light d-flex align-items-center justify-content-center px-3 py-2 text-muted"
                            style={{ fontSize: '13px', borderRadius: '8px', fontWeight: '600', border: '1px solid #efefef' }}
                        >
                            <IconArrowsSort size={16} color="#7a3a5e" />
                        </button>
                    </OverlayTrigger>
                    <Dropdown
                        style={{ zIndex: 99, }}
                        show={openFilter}
                        ref={filterDropRef}
                    >
                        <Dropdown.Toggle
                            as="button"
                            onClick={(e) => {
                                e.preventDefault()
                                setOpenFilter(prev => !prev)
                            }}
                            className="btn btn-light d-flex align-items-center gap-2 px-3 py-2 text-muted no-arrow"
                            style={{ fontSize: '13px', borderRadius: '8px', fontWeight: '600', border: '1px solid #efefef' }}
                        >
                            <IconFilter size={16} color="#7a3a5e" />
                            {filter}
                            <i className="fa-solid fa-chevron-down align-middle ms-1 d-inline-block"></i>
                        </Dropdown.Toggle>
                        <Dropdown.Menu
                            className="shadow"
                            style={{ zIndex: 9999, marginTop: '3px', minWidth: '260px' }}
                            align={'end'}
                            autoClose={false}
                        >
                            <Dropdown.Item
                                onClick={() => {
                                    setFilter(`All Followup`);
                                    clearSelection()
                                    setOffset(0);
                                    setShowCustomInputs(false);
                                    setOpenFilter(false);
                                }}
                            >
                                All FollowUp
                            </Dropdown.Item>
                            <Dropdown.Item
                                onClick={() => {
                                    setFilter(`Today Followup`);
                                    clearSelection()
                                    setOffset(0);
                                    setShowCustomInputs(false);
                                    setOpenFilter(false);
                                }}
                            >
                                Today FollowUp
                            </Dropdown.Item>
                            <Dropdown.Item
                                onClick={() => {
                                    setFilter(`Due Followup`);
                                    clearSelection()
                                    setOffset(0);
                                    setShowCustomInputs(false);
                                    setOpenFilter(false);
                                }}
                            >
                                Due FollowUp
                            </Dropdown.Item>
                            <div className="px-3 py-2 border-top">
                                <div
                                    role="button"
                                    style={{ cursor: 'pointer', fontSize: '14px' }}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        setShowCustomInputs(prev => !prev);
                                    }}
                                >
                                    Custom FollowUp
                                </div>

                                {showCustomInputs && (
                                    <div
                                        className="d-flex flex-column gap-2 mt-2"
                                        onClick={(e) => e.stopPropagation()}
                                    >
                                        <div className="d-flex gap-2 mt-2">
                                            <input
                                                type="date"
                                                className="form-control"
                                                value={customFrom}
                                                onChange={(e) => setCustomFrom(e.target.value)}
                                            />

                                            <input
                                                type="date"
                                                className="form-control"
                                                value={customTo}
                                                onChange={(e) => setCustomTo(e.target.value)}
                                            />
                                        </div>
                                        <div className="d-flex flex-column gap-2 mt-2">
                                            <div className="w-100"
                                                onClick={(e) => e.stopPropagation()}
                                            >
                                                <Select
                                                    options={pipelineSelectOptions}
                                                    value={
                                                        selectedPipeline
                                                            ? {
                                                                value: selectedPipeline.pipeline_id,
                                                                label: selectedPipeline.pipeline_name,
                                                            }
                                                            : null
                                                    }
                                                    onChange={(selected) => {
                                                        setSelectedPipeline(selected?.data || null);
                                                    }}
                                                    placeholder="Select Pipeline"
                                                    isSearchable
                                                    styles={{
                                                        control: (base) => ({
                                                            ...base,
                                                            minHeight: "38px",
                                                            fontSize: "14px",
                                                        }),
                                                        menuPortal: (base) => ({
                                                            ...base,
                                                            zIndex: 99999,
                                                        }),
                                                        placeholder: (base) => ({
                                                            ...base,
                                                            paddingLeft: "0.8rem"
                                                        })
                                                    }}
                                                    menuPortalTarget={document.body}
                                                    menuPosition="fixed"
                                                    menuShouldBlockScroll={true}
                                                    captureMenuScroll={true}
                                                />
                                            </div>

                                            <div>
                                                <Select
                                                    options={ownerOptions.map((owner) => ({
                                                        value: owner.id,
                                                        label: owner.label,
                                                    }))}
                                                    value={selectedOwner}
                                                    onChange={(selectedOption) => {
                                                        setSelectedOwner(selectedOption || null);
                                                    }}
                                                    isSearchable
                                                    styles={{
                                                        control: (base) => ({
                                                            ...base,
                                                            minHeight: "38px",
                                                            fontSize: "14px",
                                                        }),
                                                        placeholder: (provided) => ({
                                                            ...provided,
                                                            paddingLeft: "11px",
                                                        }),
                                                        menuPortal: (base) => ({
                                                            ...base,
                                                            zIndex: 99999,
                                                        }),
                                                    }}
                                                    placeholder="Select Owner"
                                                    menuPortalTarget={document.body}
                                                    menuPosition="fixed"
                                                    menuShouldBlockScroll={true}
                                                    captureMenuScroll={true}
                                                />
                                            </div>

                                        </div>
                                        <div className="d-flex align-items-center w-100 justify-content-end gap-2">
                                            <button
                                                className="btn btn-sm btn-default-outline w-50"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    clearSelection()
                                                    setOffset(0);
                                                }}
                                            >
                                                Clear Selection
                                            </button>
                                            <button
                                                className="btn btn-sm btn-default w-50"
                                                onClick={async (e) => {
                                                    e.stopPropagation();
                                                    setFilter('Custom Followup');
                                                    setOffset(0);
                                                    await fetchMyfollowUp('Custom Followup');
                                                    setOpenFilter(false);
                                                }}
                                            >
                                                Submit
                                            </button>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </Dropdown.Menu>
                    </Dropdown>
                    </div>
                </div>
                {
                    (myFollowUP?.length ?? 0) > 0 ?
                        <>
                            {myFollowUP.map((item, index) => {
                                const cardColors = ["#2b0dff05", "#ff330005"]
                                const cardColor = cardColors[index % cardColors.length]

                                // New logic for setting followup date and time
                                const today = new Date()
                                const todayStr = today.toISOString().split("T")[0]

                                const overdue = item.followup_date && item.followup_date < todayStr
                                return <>
                                    <div
                                        key={item.id}
                                        className={`meeting-card  position-relative ${currId === (item.type?.trim()?.slice(0, 4) === "lead"
                                            ? item?.lead_id
                                            : item?.deal_id)
                                            ? "shadow-sm"
                                            : ""
                                            } `}
                                        style={{
                                            backgroundColor: cardColor,
                                            cursor: "pointer",
                                            border:
                                                currId === (item.type?.trim()?.slice(0, 4) === "lead"
                                                    ? item?.lead_id
                                                    : item?.deal_id)
                                                    ? cardColor === "#2b0dff05"
                                                        ? " 2px solid #ada4ff80"
                                                        : "2px solid #ffac9b80"
                                                    : "1px solid #efefef",
                                            transition: "border 0.2s ease-in-out",
                                        }}
                                        onClick={() => {
                                            setCurrId(item.type?.trim()?.slice(0, 4) === "lead" ? item?.lead_id : item?.deal_id)
                                            setCurrPipelineId(item?.pipeline_id)
                                            setCurrModule(item.type?.toLowerCase()?.slice(0, 4))
                                        }}
                                    >
                                        <div className="meeting-info">
                                            <h4
                                                className="meeting-title"
                                                style={{ textTransform: "capitalize", fontSize: "14px", fontWeight: 600, marginBottom: "10px" }}
                                            >
                                                <span
                                                    className="contact-name fw-semibold cursor-pointer transition-all"
                                                    style={{ fontSize: '14px', textTransform: "capitalize", whiteSpace: "nowrap" }}
                                                >
                                                    {item?.contact_name}
                                                </span>
                                            </h4>
                                        </div>
                                        <div className="d-flex gap-3 align-items-center w-100">
                                            <div className="d-flex align-items-start flex-fill" style={{ minWidth: 0 }}>
                                                <div
                                                    className="d-flex align-items-center justify-content-center rounded-full"
                                                    style={{
                                                        backgroundColor: "#f1f5f9",
                                                        borderRadius: "50%",
                                                        minWidth: "32px",
                                                        height: "32px",
                                                        color: "#2656a8",
                                                        marginTop: "4px",
                                                        border: "1px solid #d5e4ff",
                                                        marginRight: '8px'
                                                    }}
                                                >
                                                    <IconCalendarEvent size={14} className="" stroke={1.5} />
                                                </div>
                                                <div
                                                    className="d-flex flex-column align-items-start flex-fill"
                                                    style={{
                                                        paddingRight: '1rem',
                                                        minWidth: 0,
                                                    }}
                                                >
                                                    <span htmlFor="followup-due-date" className="d-flex align-items-center" style={{ fontSize: '12px', ...miniLabelStyle }}>Due Date</span>
                                                    <span id="followup-due-date text-truncate" style={{ fontSize: '0.833rem', color: `${overdue && "red"} `, fontWeight: 400 }}> {formatDate(item?.followup_date)}</span>
                                                </div>
                                            </div>
                                            <div className="d-flex align-items-start flex-fill" style={{ minWidth: 0 }}>
                                                <div
                                                    className="d-flex align-items-center justify-content-center rounded-full"
                                                    style={{
                                                        backgroundColor: "#f1f5f9",
                                                        borderRadius: "50%",
                                                        minWidth: "32px",
                                                        height: "32px",
                                                        color: "#2656a8",
                                                        marginTop: "4px",
                                                        border: "1px solid #d5e4ff",
                                                        marginRight: '8px'
                                                    }}
                                                >
                                                    <IconBriefcase2 size={14} className="" stroke={1.5} />
                                                </div>
                                                <div
                                                    className="d-flex flex-column align-items-start flex-fill"
                                                    style={{
                                                        paddingRight: '1rem',
                                                        minWidth: 0,
                                                    }}
                                                >
                                                    <span htmlFor="followup-due-date" className="d-flex align-items-center" style={{ fontSize: "12px", ...miniLabelStyle }}>Type</span>
                                                    <span
                                                        id="followup-due-date text-truncate"
                                                        style={{
                                                            fontSize: '0.833rem',
                                                            textTransform: 'capitalize',
                                                            whiteSpace: 'nowrap',
                                                            overflow: 'hidden',
                                                            textOverflow: 'ellipsis',
                                                            width: '100%',
                                                            fontWeight: 400
                                                        }}
                                                    >
                                                        {item?.type || '-'}
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="d-flex align-items-start flex-fill" style={{ minWidth: 0 }}>
                                                <div
                                                    className="d-flex align-items-center justify-content-center fullounded-2"
                                                    style={{
                                                        backgroundColor: "#f1f5f9",
                                                        borderRadius: "50%",
                                                        minWidth: "32px",
                                                        height: "32px",
                                                        marginTop: "4px",
                                                        border: "1px solid #d5e4ff",
                                                        color: "#2656a8",
                                                        marginRight: '8px'
                                                    }}
                                                >
                                                    <IconSitemap size={14} className="" stroke={1.5} />
                                                </div>
                                                <div
                                                    className="d-flex flex-column align-items-start flex-fill"
                                                    style={{ minWidth: 0 }}
                                                >
                                                    <span htmlFor="followup-due-date" className="d-flex align-items-center" style={{ fontSize: "12px", ...miniLabelStyle }}>Pipeline Name</span>
                                                    <span
                                                        id="followup-due-date text-truncate "
                                                        style={{
                                                            whiteSpace: 'nowrap',
                                                            overflow: 'hidden',
                                                            textOverflow: 'ellipsis',
                                                            width: '120px',
                                                            display: 'block',
                                                            fontSize: '0.833rem',
                                                            fontWeight: 400
                                                        }}
                                                    >
                                                        {item?.pipeline_name || '-'}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div >

                                </>
                            })}
                            <div
                                className=" d-flex justify-content-end align-items-center mt-2"
                            >
                                <FilterPagination
                                    offset={Math.floor(offset / limit)}
                                    setOffset={(pageIndex) => setOffset(pageIndex * limit)}
                                    handlePageChange={(selectedItem) => {
                                        setOffset(selectedItem.selected * limit)
                                    }}
                                    pageCount={pageCount}
                                    limit={limit}
                                />
                            </div>
                        </>
                        :
                        <div
                            className="d-flex justify-content-center align-items-center"
                            style={{ position: "absolute", left: "25%", top: "30%" }}
                        >
                            <img
                                src={nodata}
                                alt=""
                                style={{ width: "17rem", marginTop: "0" }}
                            />
                        </div>
                }

            </Col>

            {
                !currId &&
                <Col md={7} style={{ paddingLeft: '5px' }}>
                    <div className="h-100 d-flex flex-column align-items-center justify-content-center text-muted p-5 border rounded-3 bg-light-subtle" style={{ borderStyle: 'dashed !important' }}>
                        <IconChecklist size={48} stroke={1} className="mb-3 opacity-50" />
                        <p className="fw-medium">Select a Followup from the list to view details</p>
                    </div>
                </Col>
            }

            {
                (currId !== null && currModule === "lead" && currPipelineId) &&
                <FollowUpPage
                    id={currId}
                    setCurrId={setCurrId}
                    module_name={'lead'}
                    followupGrant={leadsFollowupGrant}
                    pipeline_id={currPipelineId}
                    fetchMyfollowUp={fetchMyfollowUp}
                    currentFollowupFilter={filter}
                />
            }
            {
                (currId !== null && currModule === "deal" && currPipelineId) &&
                <FollowUpPage
                    id={currId}
                    setCurrId={setCurrId}
                    module_name={'deal'}
                    followupGrant={leadsFollowupGrant}
                    pipeline_id={currPipelineId}
                    fetchMyfollowUp={fetchMyfollowUp}
                    currentFollowupFilter={filter}
                />
            }
        </Row >
    );
};

const miniLabelStyle = {
    fontSize: "12px",
    fontWeight: "400",
    color: "#94a3b8",
    display: "block",
    marginBottom: "2px"
};
